export const PRODUCT_REQUEST_ARRIVAL = "PRODUCT_REQUEST_ARRIVAL";
export const PRODUCT_REQUEST_RINGS = "PRODUCT_REQUEST_RINGS";
export const PRODUCT_REQUEST_EARRINGS = "PRODUCT_REQUEST_EARRINGS";
// export const PRODUCT_REQUEST_COLLECTION = "PRODUCT_REQUEST_COLLECTION"
// export const PRODUCT_REQUEST_WISHLIST = "PRODUCT_REQUEST_WISHLIST"
export const SINGLE_PRODUCT_REQUEST = "SINGLE_PRODUCT_REQUEST_CART";
export const PRODUCT_REQUEST_BRACELETS = "PRODUCT_REQUEST_BRACELETS";
export const IsLoading = "isLoading";
export const IsError = "isError";
export const TOTALPAGE = "TOTALPAGE";

// export const GETCART="GETCART"
// export const UPDATECART="UPDATECART"
// export const ADDTOCART="ADDTOCART"
// export const DELETECART="DELETECART"
